import { render, staticRenderFns } from "./Article.vue?vue&type=template&id=5a898499&scoped=true&"
import script from "./Article.js?vue&type=script&lang=js&"
export * from "./Article.js?vue&type=script&lang=js&"
import style0 from "./Article.scoped.scss?vue&type=style&index=0&id=5a898499&lang=scss&scoped=true&"
import style1 from "./Article.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a898499",
  null
  
)

export default component.exports